<template>
  <div>
    <template v-for="(item, index) in value">
      <v-layout :key="index" class="mb-2 pa-1 z-border-red">
        <v-flex shrink>
          <v-btn small icon outline @click="handleRemoveWrapUp(index)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </v-flex>
        <v-flex>
          <template v-for="(wrap_up_route, windex) in item">
            <v-chip :key="`label_${windex}`" label color="primary" text-color="white">{{
              wrap_up_route.title
            }}</v-chip>
            <em
              v-if="windex + 1 < item.length"
              :key="`chevron_${windex}`"
              class="fas fa-chevron-right mx-1"
            />
          </template>
        </v-flex>
      </v-layout>
    </template>
    <v-btn block @click="showAddWrapUp = true">
      <v-icon class="mr-1">add</v-icon>
      {{ $t('Add wrap up') }}
    </v-btn>
    <v-dialog v-model="showAddWrapUp" persistent max-width="400px" scrollable>
      <WrapUpDialog
        v-if="wrapUpOptions && showAddWrapUp"
        v-model="currentWrapUp"
        :wrap-up-options="wrapUpOptions"
        @onClose="onClose"
        @onSave="onSave"
      />
    </v-dialog>
  </div>
</template>

<script>
import { convertWrapUpRoute } from '@/utils/wrapUp'
import WrapUpDialog from './WrapUpDialog'

export default {
  name: 'WrapUpInput',
  components: {
    WrapUpDialog
  },
  props: ['value'],
  data() {
    return {
      wrapUpOptions: undefined,
      showAddWrapUp: false,
      currentWrapUp: []
    }
  },
  async mounted() {
    await this.handleLoadWrapUp()
  },
  methods: {
    handleRemoveWrapUp(index) {
      const val = [...this.value]
      val.splice(index, 1)
      this.$emit('onUpdate', val)
    },
    onSave(option) {
      this.$emit('onUpdate', [...this.value, option])
      //   this.showAddWrapUp = false
      //   this.$emit('input', option)
    },
    onClose() {
      this.showAddWrapUp = false
      this.currentWrapUp = []
    },
    async handleLoadWrapUp() {
      const result = await this.$store.dispatch('loadWrapUp', {})

      if (result) {
        this.wrapUpOptions = result.data.map((wrapUp) => {
          return {
            level: 0,
            title: wrapUp.wrap_up,
            subWrapUp: convertWrapUpRoute(wrapUp.wrap_up_route)
          }
        })
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUpInput/index.vue